import { useContext } from "react";
import { Header, Footer } from "./index";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../../Context";
import { LOGIN } from "../../routes";

const Layout = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const isLoggedIn = Boolean(user);
  //Might need to add code in the public layout
  if (!isLoggedIn && location.pathname !== LOGIN) {
    return <Navigate to={LOGIN} />;
  }

  return (
    <div className="min-h-[100dvh] min-h-[calc(100dvh-constant(safe-area-inset-bottom))] min-h-[calc(100dvh-env(safe-area-inset-bottom))]">
      <header className="sticky top-[calc(env(safe-area-inset-top))] z-50 bg-white h-16">
        <Header />
      </header>
      <div>
        <main className="overflow-y-auto" style={{ height: 'calc(100dvh - 4rem)' }}>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
